import { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import ApplicationInfoEval from "../../Pages/Manager/ApplicationByEvaluator/ApplicationBySubTask/ApplicationInfoEval";
import MarksTable from "../../Pages/Manager/ApplicationByEvaluator/ApplicationBySubTask/MarksTable";
import ShortListInfo from "../../Pages/Manager/ApplicationByEvaluator/ApplicationBySubTask/ShortListInfo";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { useDispatch, useSelector } from "react-redux";
import { UpdateAllMarks } from "../../Redux/Reducers/Manager/Marks";
import {
  ChangeStatusAndEditFlowActionEvaluator,
  GetOneFlowActionEvaluator,
  GetShortListNumbers,
  UpdateFlowActionEvaluator,
} from "../../Redux/Reducers/Manager/FlowActionEvaluator";
import {
  GetSpecificRowSubTask,
  SaveSubTaskForEvaluation,
} from "../../Redux/Reducers/Manager/SubTask";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { SetArrayDataCheckBoks } from "../../Redux/Reducers/Shared/CheckBox";

const ApplicationByEvaluatorContainer = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { subTaskId } = useParams();
  const [isShortList, setisShortList] = useState(null);
  const [ReasonDescription, setReasonDescription] = useState(null);
  const SubTaskById = useSelector((state) => state.SubTask.SubTaskById);
  const lang = useSelector((state) => state.languageReducer.Language);
  const loadingSubTaskById = useSelector(
    (state) => state.SubTask.loadingSubTaskById
  );
  const ApplicationBySubTask = useSelector(
    (state) => state.SubTask.ApplicationBySubTask
  );
  const MarksList = useSelector((state) => state.MarksManager.MarksManager);
  const FlowActionEvaluator = useSelector(
    (state) => state.FlowActionEvaluator.FlowActionEvaluator
  );
  const ShortListNumbers = useSelector(
    (state) => state.FlowActionEvaluator.ShortListNumbers
  );
  const UserInfo = useSelector((state) => state.UserInfo.UserInfo);

  const [refrish, setRefrish] = useState(0);
  useEffect(() => {
    dispatch(GetSpecificRowSubTask({ subTaskId: subTaskId }));
    dispatch(
      GetOneFlowActionEvaluator({
        subTaskId: subTaskId,
      })
    );
  }, []);
  useEffect(() => {
    dispatch(
      GetShortListNumbers({
        subjectId: ApplicationBySubTask?.subjectId,
        userId: ApplicationBySubTask?.userId,
      })
    );
  }, [ApplicationBySubTask?.subjectId]);
  const saveData = async () => {
    const markSaved = await dispatch(
      UpdateAllMarks({ eV_NT_MarksEvaluationModel: MarksList })
    );

    const saveSubTask = await dispatch(
      SaveSubTaskForEvaluation({
        toOrderOnShortList:
          isShortList != null ? isShortList : FlowActionEvaluator.isShortlisted,
        explainWhy: ReasonDescription
          ? ReasonDescription
          : FlowActionEvaluator.reasonDescription,
        subTaskId: subTaskId,
      })
    );
    if (markSaved.payload && saveSubTask.payload) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: lang == "en" ? "Saved Successfully" : "تم حفظ المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
    }
    setRefrish(refrish + 1);
  };

  const saveSubTaskAndflow = async (statusGuid) => {
    const validate = await validation();

    if (validate) {
      const markSaved = await dispatch(
        UpdateAllMarks({ eV_NT_MarksEvaluationModel: MarksList })
      );
      const save = await dispatch(
        ChangeStatusAndEditFlowActionEvaluator({
          toOrderOnShortList:
            isShortList != null
              ? isShortList
              : FlowActionEvaluator.isShortlisted,
          explainWhy: ReasonDescription
            ? ReasonDescription
            : FlowActionEvaluator.reasonDescription,
          subStatusId: statusGuid,
          subTaskId: subTaskId,
          statusChange: statusGuid,
        })
      );
      console.log(
        save.payload.code == 200,
        "dDDDDDDDDDDDDDDDDDDDDDDD",
        markSaved.payload.code == 200
      );

      if (save.payload?.code == 200 && markSaved.payload?.code == 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: lang == "en" ? "Saved Successfully" : "تم حفظ المعلومات بنجاح",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        navigate(`/ResearchersAward/manager/evaluation/ApplicationByEvaluator/`);
      }
    }
  };
  console.log(ShortListNumbers, "ShortListNumbers");

  const validation = async () => {
    const validationMassage = [];
    const missingMarks = MarksList?.filter((q) => q.evalMark === null);
    if (missingMarks.length > 0) {
      missingMarks.map((ele) => {
        validationMassage.push(
          lang == "en"
            ? ele.questionNameEn + ": Mark "
            : ele.questionName + " : العلامة"
        );
      });
    }

    if (isShortList == null) {
      validationMassage.push(
        lang == "en"
          ? "Is the order on the shortlist?"
          : "هل الطلب ضمن القائمة القصيرة؟"
      );
    }
    if (ReasonDescription == null || ReasonDescription == "") {
      validationMassage.push(
        lang == "en" ? " Explain the reason" : "توضيح السبب"
      );
    }
    if (isShortList == true) {
      if (
        ShortListNumbers?.numberRequestsAdded> ShortListNumbers?.numberAllowed
      ) {
        validationMassage.push(
          "يجب ان لايتجاوز عدد الطلبات المضافة كقائمة قصيرة العدد المسموح به "
        );
      }
    }
    if (validationMassage.length > 0) {
      Swal.fire({
        icon: "warning",
        title:
          lang == "en"
            ? "Please fill in the following fields"
            : "الرجاء تعبئة الحقول التالية",
        html: `
              <div style="text-align: ${
                lang == "en" ? "left" : "right"
              }; direction: ${lang == "en" ? "ltr" : "rtl"}; font-size: 16px;">
                <ul style="list-style-type: none; padding: 0;">
                  ${validationMassage
                    .map(
                      (field) =>
                        `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                    )
                    .join("")}
                </ul>
              </div>
            `,
        confirmButtonText: lang == "en" ? "Ok" : "حسناً",
        customClass: {
          popup: "swal2-border-radius",
        },
      });
      return false;
    }

    return true;
  };
  const EditeSubTaskAndflow = async (statusGuid) => {
    const save = await dispatch(
      ChangeStatusAndEditFlowActionEvaluator({
        toOrderOnShortList:
          isShortList != null ? isShortList : FlowActionEvaluator.isShortlisted,
        explainWhy: ReasonDescription
          ? ReasonDescription
          : FlowActionEvaluator.reasonDescription,
        subStatusId: statusGuid,
        subTaskId: subTaskId,
        statusChange: statusGuid,
      })
    );
    if (save.payload) {
      window.location.reload();
    }
  };
  console.log(UserInfo, "ddddddddddddddddddddddssss", SubTaskById);

  const role = JSON.parse(UserInfo?.roles)?.map((role) => role?.RoleId);
  const disabled =
    SubTaskById?.taskStatusId != "60d6bc25-9608-4585-babf-345116f3c0bb" ||
    UserInfo.UserId != SubTaskById?.userSSOId;
  return SubTaskById ? (
    <>
      <SharedDiv
        showTitle={true}
        titleNameEN="Application Information"
        titleNameAR="معلومات الطلب"
        lang={lang}
        titleName="معلومات الطلب"
        child={[<ApplicationInfoEval disabled={disabled} refrish={refrish} />]}
      />
      <MarksTable disabled={disabled} />
      <SharedDiv
        showTitle={true}
        titleNameEN="short list Information"
        titleNameAR=" معلومات القائمة القصيرة"
        lang={lang}
        child={[
          <ShortListInfo
            setisShortList={setisShortList}
            setReasonDescription={setReasonDescription}
            userId={SubTaskById?.uS_UserGuid}
            disabled={disabled}
            refrish={refrish}
          />,
        ]}
      />

      <div className="containerButtonMAin">
        <div className="SaveButtonMarks">
          <ButtonAHSF
            type={"submitter"}
            fieldsName="ShowApplication"
            lang={lang}
            onClick={() => {
              window.open(
                `/ResearchersAward/manager/ViewApplication/ApplicationInformation/` +
                  SubTaskById?.applicationInformationId,
                "_blank"
              );
            }}
            disabled={false}
            show={true}
          />
          {!disabled ? (
            <ButtonAHSF
              type={"submitter"}
              fieldsName="SaveButton"
              lang={lang}
              text="حفظ"
              onClick={() => {
                saveData();
              }}
              disabled={false}
              title={"حفظ"}
              show={true}
            />
          ) : (
            ""
          )}
        </div>
        {SubTaskById?.taskStatusId == "3e8c7ab5-6fcc-4884-9831-2cb8157235eb" &&
        UserInfo?.UserId == SubTaskById?.userSSOId ? (
          <ButtonAHSF
            type={"submitter"}
            fieldsName="editEval"
            lang={lang}
            text={" "}
            onClick={() => {
              EditeSubTaskAndflow("60d6bc25-9608-4585-babf-345116f3c0bb");
            }}
            disabled={false}
            title={"اخذ اجراء"}
            show={true}
          />
        ) : (
          ""
        )}
        {SubTaskById?.taskStatusId == "60d6bc25-9608-4585-babf-345116f3c0bb" &&
        UserInfo?.UserId == SubTaskById?.userSSOId ? (
          <ButtonAHSF
            type={"submitter"}
            fieldsName="submitEval"
            lang={lang}
            text={" "}
            onClick={() => {
              saveSubTaskAndflow("3e8c7ab5-6fcc-4884-9831-2cb8157235eb");
            }}
            disabled={false}
            title={"اخذ اجراء"}
            show={true}
          />
        ) : (
          ""
        )}
      </div>
    </>
  ) : (
    ""
  );
};

export default ApplicationByEvaluatorContainer;
